import React, {
    useEffect,
    useState,
} from "react";
import api, { showAlert } from "../../util/api";

const emptyForm = {
    title: "",
    icon: "",
    description: "",
    active: true,
};

const Impact = () => {

    const [impacts, setImpacts] =
        useState([]);

    const [form, setForm] =
        useState(emptyForm);

    const [editingId, setEditingId] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [message, setMessage] =
        useState("");

    useEffect(() => {
        fetchImpacts();
    }, []);


    const fetchImpacts = async () => {

        try {

            const response =
                await api.get("/admin/impact");

            const result =
                await response.data;

            if (result.success) {

                setImpacts(
                    result.data || []
                );
            }

        } catch (error) {

            console.error(
                "Error fetching impacts:",
                error
            );

        } finally {

            setLoading(false);
        }
    };


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked,
        } = e.target;

        setForm((prev) => ({
            ...prev,

            [name]:
                type === "checkbox"
                    ? checked
                    : value,
        }));
    };


    const resetForm = () => {

        setForm(emptyForm);

        setEditingId(null);
    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);

        setMessage("");

        const isEditing =
            Boolean(editingId);

        try {

            /*  isEditing
                        ? `/api/admin/impact/${editingId}`
                        : "/api/admin/impact", */


            let response;


            if (isEditing) {

                response = await api.put(`/admin/impact/${editingId}`, form);
            } else {
                response = await api.post("/admin/impact", form);
            }


            const result =
                await response.data;

            if (result.success === false) {

                throw new Error(
                    result.message ||
                    "Unable to save impact."
                );
            }

            setMessage(
                isEditing
                    ? "Impact updated successfully."
                    : "Impact created successfully."
            );

            showAlert('success', 'success!', isEditing
                ? "Impact updated successfully."
                : "Impact created successfully."
            );

            resetForm();

            await fetchImpacts();

        } catch (error) {

            setMessage(
                error.message
            );

        } finally {

            setSaving(false);
        }
    };


    const editImpact = (impact) => {

        setEditingId(impact.id);

        setForm({
            title:
                impact.title || "",

            icon:
                impact.icon || "",

            description:
                impact.description || "",

            active:
                Boolean(
                    impact.active
                ),
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    const deleteImpact =
        async (impact) => {

            const confirmed =
                window.confirm(
                    `Delete "${impact.title}"?`
                );

            if (!confirmed) {
                return;
            }

            try {


            

                const   response = await api.delete(`/admin/impact/${impact.id}`);

                const result =
                    await response.data;

                if (result.success === false) {

                    throw new Error(
                        result.message ||
                        "Unable to delete impact."
                    );
                }

                showAlert('success', 'success!', "Impact deleted successfully.");

                setMessage(
                    "Impact deleted successfully."
                );

                await fetchImpacts();

            } catch (error) {

                setMessage(
                    error.message
                );
            }
        };


    if (loading) {

        return (
            <div className="admin-page-loading">
                Loading impact areas...
            </div>
        );
    }


    return (

        <div className="admin-impact-page">

            <div className="admin-page-header">

                <div>

                    <span className="admin-page-eyebrow">
                        WEBSITE CONTENT
                    </span>

                    <h1>
                        Impact Areas
                    </h1>

                    <p>
                        Manage the key areas of
                        service and development.
                    </p>

                </div>

            </div>


            {message && (

                <div className="admin-form-message">
                    {message}
                </div>

            )}


            <div className="admin-panel">

                <div className="admin-panel-header">

                    <div>

                        <span>
                            {editingId
                                ? "EDIT IMPACT"
                                : "NEW IMPACT"}
                        </span>

                        <h2>
                            Impact Area
                        </h2>

                    </div>

                </div>


                <form
                    className="admin-form"
                    onSubmit={handleSubmit}
                >

                    <div className="admin-form-row">

                        <div className="admin-form-group">

                            <label>
                                Impact Title
                            </label>

                            <input
                                type="text"
                                name="title"
                                value={form.title}
                                onChange={handleChange}
                                placeholder="Education & Human Capital Development"
                                required
                            />

                        </div>


                        <div className="admin-form-group">

                            <label>
                                Icon
                            </label>

                            <input
                                type="text"
                                name="icon"
                                value={form.icon}
                                onChange={handleChange}
                                placeholder="🎓"
                            />

                        </div>

                    </div>


                    <div className="admin-form-group">

                        <label>
                            Description
                        </label>

                        <textarea
                            name="description"
                            value={
                                form.description
                            }
                            onChange={
                                handleChange
                            }
                            rows="5"
                            placeholder="Describe this impact area..."
                        />

                    </div>


                    <label className="admin-toggle">

                        <input
                            type="checkbox"
                            name="active"
                            checked={form.active}
                            onChange={
                                handleChange
                            }
                        />

                        <span className="admin-toggle-slider" />

                        <span>

                            <strong>
                                Active
                            </strong>

                            <small>
                                Display this impact area
                                on the public website.
                            </small>

                        </span>

                    </label>


                    <div className="admin-career-form-actions">

                        <button
                            type="submit"
                            className="admin-primary-button"
                            disabled={saving}
                        >

                            {saving
                                ? "Saving..."
                                : editingId
                                    ? "Update Impact"
                                    : "Add Impact"}

                        </button>


                        {editingId && (

                            <button
                                type="button"
                                className="admin-secondary-button"
                                onClick={
                                    resetForm
                                }
                            >
                                Cancel
                            </button>

                        )}

                    </div>

                </form>

            </div>


            <div className="admin-panel admin-impact-list">

                <div className="admin-panel-header">

                    <div>

                        <span>
                            IMPACT AREAS
                        </span>

                        <h2>
                            Current Areas
                        </h2>

                    </div>

                    <span className="admin-record-count">
                        {impacts.length} Areas
                    </span>

                </div>


                <div className="admin-impact-grid">

                    {impacts.length === 0 ? (

                        <div className="admin-empty-state">
                            No impact areas added yet.
                        </div>

                    ) : (

                        impacts.map((impact) => (

                            <div
                                className="admin-impact-card"
                                key={impact.id}
                            >

                                <div className="admin-impact-card-top">

                                    <span className="admin-impact-icon">
                                        {impact.icon ||
                                            "◉"}
                                    </span>

                                    <span
                                        className={
                                            impact.active
                                                ? "admin-status active"
                                                : "admin-status inactive"
                                        }
                                    >
                                        {impact.active
                                            ? "ACTIVE"
                                            : "HIDDEN"}
                                    </span>

                                </div>


                                <h3>
                                    {impact.title}
                                </h3>


                                <p>
                                    {
                                        impact.description
                                    }
                                </p>


                                <div className="admin-impact-project-count">

                                    {
                                        impact.projects_count
                                    } Projects

                                </div>


                                <div className="admin-career-actions">

                                    <button
                                        type="button"
                                        onClick={() =>
                                            editImpact(
                                                impact
                                            )
                                        }
                                    >
                                        Edit
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            deleteImpact(
                                                impact
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </div>

                        ))

                    )}

                </div>

            </div>

        </div>
    );
};

export default Impact;